import React, { Component } from 'react';
import { message, Table, Select, Drawer, DatePicker } from 'antd';
import { map } from 'lodash';
import moment from 'moment-timezone';
import AddUser from './AddUSer';
import EditUser from './EditUser';
import AddGroup from './AddGroup'
import EditGroup from './EditGroup';

import DataTable from '../../DataTable';
import Header from '../../../Common/Component/Header';
import Sidebar from '../../../Common/Component/Sidebar';
import Loader from "../../../Common/Component/Loader";
import {errorHandle} from "../../../Common/errorHandle";

const { Option } = Select;
const { RangePicker } = DatePicker;
class UserList extends Component {

  state = {
    userList: [],
    groupList: [],
    franchiseList: [],
    roleList: [],
    User_details: {},
    group_details: {},
    user_list_filter: { created_at__lte: null, created_at__gte: null, staff_profile__field_office__uuid: '', status: '', role: '' },
    group_list_filter: { status: '' },
    user_list_pagination: { showSizeChanger: false, pageSize: 15, ordering: "", staff_profile__field_office__uuid: '' },
    group_list_pagination: { showSizeChanger: false, pageSize: 15, ordering: "" },
    isNav: '',
    delete_id: '',
    search_value: '',
    active_pagination: '15',
    loader: false,
    openNav: false,
    is_user_table: true,
    is_add_user: false,
    is_add_group: false,
    is_edit_group: false,
    is_add_user_Active: false,
    is_update_user: false,
    is_user_filter: false,
    is_disable_franchise: false,
    visible: false,
    is_add_new_user: true,
    is_edit_user: true,
    is_delete_user: true,
  }

  componentDidMount = async () => {
    //Get User role
    const user = JSON.parse(localStorage.getItem("authUser"));
    var roles = user?.user?.role;
    if (roles.includes(`business_dev_franchiese`) || roles.includes(`accounting_franchiese`) || roles.includes(`franchise_owner`)) {
      this.setState({ is_disable_franchise: true })
    }

    if ((roles.includes(`business_dev_franchiese`) || roles.includes(`accounting_franchiese`) || roles.includes(`service_rep`))) {
      this.setState({ is_edit_user: false })
    }

    if (roles.includes(`service_rep`)) {
      this.setState({ is_add_new_user: false })
    }

    if ((roles.includes(`accounting_franchiese`) || roles.includes(`business_dev_franchiese`) || roles.includes(`service_rep`))) {
      this.setState({ is_delete_user: false })
    }
    
    this.setState({loader: true})

    //Get User List
    await this.props.getUserList({ 'offset': 0, 'limit': 15 });
    //Get Franchise List
    this.props.getFranchiseList();

    //Get Roles List
    this.props.getRoles();

    //Get Group List
    const {is_disable_franchise, franchise_uuid} = this.getLoggedInUserRole()
    this.props.getGroupList({ 'offset': 0, 'limit': 15, field_office__uuid: is_disable_franchise ? franchise_uuid : '' });
  }

  UNSAFE_componentWillReceiveProps = (props) => {
    // message.destroy();
    const user_list_pagination = { ...this.state.user_list_pagination };
    const group_list_pagination = { ...this.state.group_list_pagination };

    //get user deetails
    if (Object.keys(props.USerEditDetails.data).length > 0 && props.USerEditDetails.data !== this.props.USerEditDetails.data) {

      this.setState({
        loader: false,
        is_update_user: true,
        User_details: props.USerEditDetails.data
      })
    }

    if (Object.keys(props.USerEditDetails.errors).length > 0 && props.USerEditDetails.errors !== this.props.USerEditDetails.errors) {
      errorHandle(props?.USerEditDetails?.errors)
      this.setState({
        loader: false,
      })
    }
    //get group deetails
    if (Object.keys(props.GroupEditDetails.data).length > 0 && props.GroupEditDetails.data !== this.props.GroupEditDetails.data) {
      // console.log("props.GroupEditDetails.data", props.GroupEditDetails.data)
      this.setState({
        loader: false,
        group_details: props.GroupEditDetails
      })
    }
    if (Object.keys(props.GroupEditDetails.errors).length > 0 && props.GroupEditDetails.errors !== this.props.GroupEditDetails.errors) {
      this.editGroupToggle(false)
      errorHandle(props?.GroupEditDetails?.errors)
      this.setState({
        loader: false,
      })

    }
    //updated user
    if (Object.keys(props.updateUser.data).length > 0 && props.updateUser.data !== this.props.updateUser.data) {
      // success message
      this.setState({
        is_update_user: false,
        loader: false
      })
      this.props.getUserList({ 'offset': 0, 'limit': this.state.active_pagination, search: this.state.search_value });
    }

    //get user list
    if (Object.keys(props.UserList.data).length > 0 && props.UserList.data !== this.props.UserList.data) {
      user_list_pagination.total = props.UserList.data.count;
      this.setState({
        userList: props.UserList.data.results,
        user_list_pagination,
        is_user_filter: false,
      })
      setTimeout(() => this.setState({loader: false}), 500)
    }
    if (Object.keys(props.UserList.errors).length > 0 && props.UserList.errors !== this.props.UserList.errors) {
      // display error messsage
      this.setState({ loader: false })
      errorHandle(props?.UserList?.errors)
    }

    //get group list
    if (Object.keys(props.GroupList.data).length > 0 && props.GroupList.data !== this.props.GroupList.data) {
      group_list_pagination.total = props.GroupList.data.count;
      this.setState({
        groupList: props.GroupList.data.results,
        group_list_pagination,
        loader: false
      })
    }
    if (Object.keys(props.GroupList.errors).length > 0 && props.GroupList.errors !== this.props.GroupList.errors) {
      // display error messsage
      this.setState({ loader: false })
      errorHandle(props?.GroupList?.errors)
    }


    //get franchise list
    if (Object.keys(props.FranchiseList.data).length > 0 && props.FranchiseList.data !== this.props.FranchiseList.data) {
      this.setState({
        franchiseList: props.FranchiseList.data.results,
        group_list_pagination,
        loader: false
      })
    }
    if (Object.keys(props.FranchiseList.errors).length > 0 && props.FranchiseList.errors !== this.props.FranchiseList.errors) {
      // display error messsage
      this.setState({ loader: false })
      errorHandle(props?.FranchiseList?.errors)
    }

    // Delete User

    if (Object.keys(props.DeleteUser.data).length > 0 && props.DeleteUser.data !== this.props.DeleteUser.data) {
      //Get User List
      this.props.getUserList({ 'offset': (user_list_pagination.current * 15) - 15, 'limit': this.state.custom_limit, search: this.state.search_value });
      // user_list_pagination.current = 1;
      this.setState({
        visible: false,
        user_list_pagination,
        delete_id: ''
      })
    }
    if (Object.keys(props.DeleteUser.errors).length > 0 && props.DeleteUser.errors !== this.props.DeleteUser.errors) {
      // display error messsage
      this.setState({ loader: false })
      errorHandle(props?.DeleteUser?.errors)
    }


    // Delete Group

    if (Object.keys(props.DeleteGroup.data).length > 0 && props.DeleteGroup.data !== this.props.DeleteGroup.data) {
      //Get User List
      const {is_disable_franchise, franchise_uuid} = this.getLoggedInUserRole()
      this.props.getGroupList({ 'offset': (group_list_pagination.current * 15) - 15, 'limit': 15, field_office__uuid: is_disable_franchise ? franchise_uuid : ''});
      // user_list_pagination.current = 1;
      this.setState({
        visible: false,
        group_list_pagination,
        delete_id: ''
      })
    }
    if (Object.keys(props.DeleteGroup.errors).length > 0 && props.DeleteGroup.errors !== this.props.DeleteGroup.errors) {
      // display error messsage
      this.setState({ loader: false })
      errorHandle(props?.DeleteGroup?.errors)
    }

    //get role list
    if (Object.keys(props.RoleList.data).length > 0 && props.RoleList.data !== this.props.RoleList.data) {
      this.setState({
        roleList: props.RoleList.data.results,
        loader: false
      })
    }
    if (Object.keys(props.RoleList.errors).length > 0 && props.RoleList.errors !== this.props.RoleList.errors) {
      // display error messsage
      this.setState({ loader: false })
      errorHandle(props?.RoleList?.errors)
    }


  }

  // get logged in user
  getLoggedInUserRole = () => {
    let authUser = JSON.parse(localStorage.getItem('authUser'))
    const logged_in_user_role = authUser?.user?.user_roles?.map(x => x.name)

    const is_franchise_owner = logged_in_user_role?.includes('franchise_owner')
    const is_account_corporate = logged_in_user_role?.includes('accounting_corporate')
    const is_business_dev_franchiese = logged_in_user_role?.includes('business_dev_franchiese')
    const is_operations_mgr = logged_in_user_role?.includes('operations_mgr')
    const is_admin = logged_in_user_role?.includes('admin')
    // const is_field_tech = logged_in_user_role?.includes('field_tech')
    const franchise_uuid = authUser?.user?.field_offices?.map(x => x.uuid);

    const is_call_center = logged_in_user_role?.includes('service_rep')
    return {is_call_center, franchise_uuid: franchise_uuid?.[0], is_admin, is_account_corporate,
      is_disable_franchise: (is_franchise_owner || is_business_dev_franchiese || is_operations_mgr)}
  }

  ////User Table///

  //render User Table
  renderUserTable = () => {
    let { userList, user_list_pagination, active_pagination } = this.state;
    return (
      <div>
        <Table
          rowKey={record => record.uuid}
          dataSource={userList}
          onChange={this.userHandleTableChange}
          pagination={user_list_pagination}
          columns={DataTable.UserList(this)}
          className="user-list"
          position={false}
          showSorterTooltip={false}
        />

        {userList.length > 0 ?
          <ul className="pagination_page_size">
            <li>
              <span>Show:</span>
            </li>
            <li>
              <span
                onClick={() => { this.setUserPageLimit('15') }}
                className={active_pagination === '15' ? 'active' : ''}
              >15</span>
            </li>
            <li>
              <span
                className={active_pagination === '30' ? 'active' : ''}
                onClick={() => { this.setUserPageLimit('30') }}>30</span>
            </li>
            <li>
              <span
                className={active_pagination === '60' ? 'active' : ''}
                onClick={() => { this.setUserPageLimit('60') }}>60</span>
            </li>
          </ul> : ''}
      </div>
    )
  }

  //Table Order and Pagination
  userHandleTableChange = (pagination, filters, sorter) => {
    let { search_value, active_pagination } = this.state;
    let user_list_pagination = this.state.user_list_pagination;
    let { user_list_filter } = this.state;
    let ordering = ''
    user_list_pagination = Object.assign(user_list_pagination, { 'current': pagination.current });

    console.log(user_list_pagination)
    if (sorter.column) {
      ordering = sorter.order === 'ascend' ? `${sorter.columnKey}` : `-${sorter.columnKey}`
    }
    else {
      ordering = ''
    }

    this.setState({
      userList: [],
      user_list_pagination,
      loader: true,
    })

    let data = {
      offset: (pagination.current * 15) - 15,
      limit: active_pagination,
      ordering,
      search: search_value,
      ...user_list_filter
    }

    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
    this.props.getUserList(data);
  }

  //set page limit
  setUserPageLimit = (custom_limit) => {
    let { search_value, user_list_pagination,user_list_filter } = this.state;
    user_list_pagination = Object.assign(user_list_pagination, { 'current': 1, 'pageSize': custom_limit,search: search_value,staff_profile__field_office__uuid:user_list_filter.staff_profile__field_office__uuid });


    this.setState({
      user_list_pagination,
      loader: true,
      active_pagination: custom_limit,
      // search_value:''
    })
    this.props.getUserList({ offset: 0, limit: custom_limit, ordering: '', search: search_value,staff_profile__field_office__uuid:user_list_filter.staff_profile__field_office__uuid });
  }

  setGroupPageLimit = (custom_limit) => {
    let { search_value, group_list_pagination } = this.state;
    group_list_pagination = Object.assign(group_list_pagination, { 'current': 1, 'pageSize': custom_limit });


    this.setState({
      group_list_pagination,
      loader: true,
      active_pagination: custom_limit,
      // search_value:''
    })
    this.props.getGroupList({ offset: 0, limit: custom_limit, ordering: '', search: search_value});
  }



  // Show Table Nav
  ShowNav = (record,) => {
    if (!this.state.openNav) {
      // attach/remove event handler
      document.addEventListener('click', this.handleOutsideClick, false);
    } else {
      document.removeEventListener('click', this.handleOutsideClick, false);
    }

    this.setState(prevState => ({
      openNav: !prevState.openNav,
      isNav: record.uuid
    }));
  }

  // hide list toggle button
  handleOutsideClick = (e) => {
    // ignore clicks on the Component itself
    if (this.node && this.node.contains(e.target)) {
      return;
    }


    this.ShowNav({ 'uuid': '' }, '');
  }

  //Edit User Action
  editUSer = (user) => {
    this.props.getUserEditDetail(user.uuid);
    if(user.role?.includes('service_rep')){
      this.props.getGroupList({ 'offset': 0, 'limit': 15, 'is_public': true});
    }
    this.setState({
      loader: true,
      is_update_user: true
    })
  }

  //Delete User Action
  deleteUSer = () => {
    // delete user api call
    this.props.deleteUser(this.state.delete_id);
    this.setState({
      loader: true
    })
  }

  //Delete Group



  deleteGroup = () => {
    // delete user api call
    this.props.deleteGroup(this.state.delete_id);
    this.setState({
      loader: true
    })
  }

  //Edit Group Details
  editGroup = group => {
    this.props.getGroupDetails(group.uuid);
    this.setState({
      loader: true,
    })
    this.editGroupToggle(true)
  }

  //Switch tab
  switchTab = (type) => {
    let { user_list_pagination, group_list_pagination } = this.state;
    const {franchise_uuid, is_disable_franchise} = this.getLoggedInUserRole()
    if (type) {

      user_list_pagination = Object.assign(user_list_pagination, {
        showSizeChanger: false, pageSize: 15, ordering: ""
      })
      this.props.getUserList({ 'offset': 0, 'limit': 15 });
      this.setState({ loader: true, is_user_table: type, user_list_pagination, search_value: '', active_pagination:'15' });
    }
    else {
      user_list_pagination = Object.assign(user_list_pagination, {
        showSizeChanger: false, pageSize: 15, ordering: ""
      })
      this.props.getGroupList({ 'offset': 0, 'limit': 15, field_office__uuid: is_disable_franchise ? franchise_uuid : '' });
      this.setState({ loader: true, is_user_table: type, group_list_pagination, search_value: '', active_pagination: '15' });
    }

  }



  ////Group Table///

  // Render Group Table
  renderGroupTable = () => {
    let { groupList, group_list_pagination, active_pagination } = this.state;
    return (
      <div>
        <Table className="group-list"
          rowKey={record => record.uuid}
          dataSource={groupList}
          onChange={this.groupHandleTableChange}
          pagination={group_list_pagination}
          columns={DataTable.GroupList(this)}
          position={false}
          showSorterTooltip={false}

        />
        {groupList.length > 0 ?
          <ul className="pagination_page_size">
            <li>
              <span>Show:</span>
            </li>
            <li>
              <span
                onClick={() => { this.setGroupPageLimit('15') }}
                className={active_pagination === '15' ? 'active' : ''}
              >15</span>
            </li>
            <li>
              <span
                className={active_pagination === '30' ? 'active' : ''}
                onClick={() => { this.setGroupPageLimit('30') }}>30</span>
            </li>
            <li>
              <span
                className={active_pagination === '60' ? 'active' : ''}
                onClick={() => { this.setGroupPageLimit('60') }}>60</span>
            </li>
          </ul> : ''}
      </div>
    )
  }



  // Group Pagination
  groupHandleTableChange = (pagination, filters, sorter) => {
    const {is_disable_franchise, franchise_uuid} = this.getLoggedInUserRole()
    // console.log("filters:::>", filters.status)

    let group_list_pagination = this.state.group_list_pagination;
    let { group_list_filter, active_pagination } = this.state;
    let ordering = ''
    group_list_pagination = Object.assign(group_list_pagination, { 'current': pagination.current });


    if (sorter.column) {
      ordering = sorter.order === 'ascend' ? `${sorter.column.key}` : `-${sorter.column.key}`
    }
    else {
      ordering = ''
    }

    this.setState({
      group_list_pagination,
      loader: true,
    })


    let data = {
      offset: (pagination.current * 15) - 15,
      limit: active_pagination, ordering,
      field_office__uuid: is_disable_franchise ? franchise_uuid : '',
      ...group_list_filter
    }

    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
    this.props.getGroupList(data);
  }


  //Toggle Add User Drawer 
  userDrawerToggle = (key) => {
    this.setState({
      is_add_user: key
    })
    this.props.getGroupList({ 'offset': 0, 'limit': 15, 'is_public': true});
  }
  // group  drawer toggle
  groupDrawerToggle = (key) => {
    this.setState({
      is_add_group: key
    })
  }

  //edit user toggle
  editGroupToggle = (key) => {
    this.setState({ is_edit_group: key })
  }

  //Toggle Add User CustomDrawer
  userEditDrawerToggle = (key) => {
    this.setState({
      is_update_user: key
    })
  }

  //Search User
  searchUser = (e) => {
    let { is_user_table } = this.state;
    const search_value = e.target.value;
    if (is_user_table) {
      if (search_value?.length >= 3 || search_value?.length === 0) {
        this.props.getUserList({ 'q': e.target.value, 'offset': 0, 'limit': 15 })
      }
      this.setState({
        search_value: e.target.value
      })
    }
    else {
      const {is_disable_franchise, franchise_uuid} = this.getLoggedInUserRole()
      if (search_value?.length >= 3 || search_value?.length === 0) {
        this.props.getGroupList({ 'search': e.target.value, 'offset': 0, 'limit': 15, field_office__uuid: is_disable_franchise ? franchise_uuid : '' })
      }
      this.setState({
        search_value: e.target.value
      })
    }

  }

  //Search User on Enter
  enterSearchUser = (e) => {
    let { is_user_table } = this.state;
    if (is_user_table) {
      this.props.getUserList({ 'q': e.target.value, 'offset': 0, 'limit': 15 })
      this.setState({
        search_value: e.target.value
      })
    }
    else {
      const {franchise_uuid, is_disable_franchise} = this.getLoggedInUserRole()
      this.props.getGroupList({ 'search': e.target.value, 'offset': 0, 'limit': 15, field_office__uuid: is_disable_franchise ? franchise_uuid : '' })
      this.setState({
        search_value: e.target.value
      })
    }
  }
  //Filter

  // Franchise Filter
  onFranchiseFilterChange = (e) => {
    let { user_list_pagination, active_pagination, search_value, user_list_filter } = this.state;

    user_list_pagination = Object.assign(user_list_pagination, { 'staff_profile__field_office__uuid': e });
    user_list_filter = Object.assign(user_list_filter, { 'staff_profile__field_office__uuid': e });

    this.setState({ loader: true, user_list_pagination, user_list_filter });
    let data = {
      offset: (user_list_pagination.current * 15) - 15 || 0,
      limit: active_pagination,
      search: search_value,
      staff_profile__field_office__uuid: e
    }

    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
    this.props.getUserList(data);
  }

  onGroupFilterChange = (e)=>{
    let { group_list_pagination, active_pagination, search_value,group_list_filter } = this.state;

    group_list_pagination = Object.assign(group_list_pagination, { 'field_office__uuid': e });
    group_list_filter = Object.assign(group_list_filter, { 'field_office__uuid': e });

    this.setState({ loader: true, group_list_pagination, group_list_filter });
    let data = {
      offset: (group_list_pagination.current * 15) - 15 || 0,
      limit: active_pagination,
      search: search_value,
      field_office__uuid: e
    }
    console.log("data",data)

    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
    this.props.getGroupList(data);
  }

  onClose = () => {
    this.setState({
      is_user_filter: false
    });
  }

  render() {
    let { loader, is_user_table, is_add_user, is_update_user,
      is_add_group, search_value, is_edit_group, franchiseList,
      is_user_filter, groupList, user_list_filter, roleList, is_disable_franchise, is_add_new_user } = this.state;
    const {is_call_center} = this.getLoggedInUserRole();

    return (
      <div id="wrapper">
        <div className="content-area">
          {/* Header */}
          <Header
            // placeholder=" Name, Phone Number, Email"
            placeholder={is_user_table ? " Name, Phone Number, Email" : " Name"}
            search_value={search_value}
            onSearch={(e) => { this.searchUser(e) }} 
            onEnter={(e) => this.setState({search_value: '', loader: true}, () => this.enterSearchUser(e))} />

          {/* Sidebar */}
          <Sidebar />
          <div className="container">
            {loader && <Loader />}
            <div className="filter_wrapper">
              <div className="left_side">
                <div className="fitem">
                  {is_user_table ?
                    <Select
                      placeholder='All Franchise'
                      defaultValue=""
                      // value={user_list_pagination.staff_profile__field_office__uuid}
                      onChange={(e) => {
                        this.onFranchiseFilterChange(e)
                      }}
                      disabled={is_disable_franchise ? true : false}
                      className="swhite">
                      <Option value="">All Franchise</Option>
                      {map(franchiseList, (item) => {
                        return (<Option key={item.uuid} >{item.name}</Option>)
                      })}
                    </Select>
                    :

                    <Select
                      placeholder='All Franchise'
                      defaultValue=""
                      // value={user_list_pagination.staff_profile__field_office__uuid}
                      onChange={(e) => {
                        this.onGroupFilterChange(e)
                      }}
                      disabled={is_disable_franchise ? true : false}
                      className="swhite">
                      <Option value="">All Group</Option>
                      {/* {map(groupList, (item) => {
                        return (<Option key={item.uuid} >{item.name}</Option>)
                      })} */}
                    </Select>
                  }
                </div>
                <ul className="tabs">
                  <li className={is_user_table ? 'active' : ''} onClick={() => { this.switchTab(true); }}>
                    <span>USER</span>
                  </li>
                  <li className={is_user_table ? '' : 'active'} onClick={() => { this.switchTab(false); }}>
                    <span>GROUPS</span>
                  </li>
                </ul>
              </div>
              <div className="right_side">
                {is_user_table ?
                  <React.Fragment>
                    <span className="ico-btn" onClick={() => { this.setState({ is_user_filter: true }) }}><i className="las la-filter"></i></span>
                    <button
                      className={is_add_new_user ? "btn btn-warning" : " btn btn-brand btn-bdr disbale_btn "}
                      disabled={is_add_new_user ? false : true}
                      onClick={() => { this.userDrawerToggle(true); this.setState({ is_update_user: false }) }}>Add New User</button>
                  </React.Fragment>
                  : <React.Fragment>
                    <button className={`btn ${is_call_center ? 'btn-brand btn-bdr disbale_btn' : 'btn-warning'}`} disabled={is_call_center} onClick={() => { this.groupDrawerToggle(true) }}    >Add New Group</button>
                  </React.Fragment>
                }
              </div>
            </div>
            <div className="data">
              {is_user_table ? this.renderUserTable() : this.renderGroupTable()}
            </div>
          </div>
        </div>


        {/* Add user */}
        {is_add_user && <Drawer
          visible={is_add_user}
          width={'820'}
          closable={false}
          className="drawer-wrapper"
        >
          <AddUser
            {...this.props}
            groupList={this.state.groupList}
            roleList={this.state.roleList}
            franchiseList={this.state.franchiseList}
            is_update_user={this.state.is_update_user}
            is_disable_franchise={this.state.is_disable_franchise}
            userDrawerToggle={() => { this.userDrawerToggle() }}
          />
        </Drawer>}

        {/* Edit user */}
        <Drawer
          visible={is_update_user}
          width={'820'}
          closable={false}
          className="drawer-wrapper"
        >

          <EditUser

            {...this.props}
            User_details={this.state.User_details}
            groupList={this.state.groupList}
            roleList={this.state.roleList}
            franchiseList={this.state.franchiseList}
            is_update_user={this.state.is_update_user}
            is_disable_franchise={this.state.is_disable_franchise}
            userEditDrawerToggle={() => { this.userEditDrawerToggle() }}
          />
        </Drawer>

        {/* Add Group */}
        <Drawer
          visible={is_add_group}
          width={'400'}
          closable={false}
          style={{ 'width': 'auto' }}
          className="drawer-wrapper"
        >
          <AddGroup
            userList={this.state.userList}
            franchiseList={this.state.franchiseList}
            groupDrawerToggle={() => { this.groupDrawerToggle() }}
            {...this.props}
            closable={false}
          />
        </Drawer>


        {/* Edit Group */}
        <Drawer
          visible={is_edit_group}
          width={'400'}
          closable={false}
          className="drawer-wrapper"
        >
          <EditGroup
            userList={this.state.userList}
            group_details={this.state.group_details}
            franchiseList={this.state.franchiseList}
            editGroupToggle={() => { this.editGroupToggle() }}
            {...this.props}

          />
        </Drawer>

        {/* User filter  */}
        <Drawer
          visible={is_user_filter}
          width={'400'}
          closable={false}

          onClose={this.onClose}
          className="drawer-wrapper"
        >
          <div className="filter_drawer_wrapper rdrawer">
            <div className="card-head" style={{ borderBottom: '0' }}>
              <h4>Filter Users</h4>
            </div>
            <div className="card-row">
              <div className="card-full">
                <div className="form-group">
                  <div className="fitem">
                    <label htmlFor="">Customer Status</label>
                    <div className="fitem-check">
                      <input
                        type="checkbox"
                        className="fitem-ck-input"
                        id="active"
                        checked={user_list_filter.is_active === true}
                        onChange={(e) => {
                          if (e.target.checked) {
                            user_list_filter = Object.assign(user_list_filter, ({ is_active: true }))
                          }
                          else {
                            user_list_filter = Object.assign(user_list_filter, ({ is_active: '' }))
                          }

                          this.setState({ user_list_filter })
                        }}
                      />
                      <label htmlFor="active" className="fitem-ck-txt">Active</label>
                    </div>
                    <div className="fitem-check">
                      <input
                        type="checkbox"
                        className="fitem-ck-input"
                        id="in_active"
                        checked={user_list_filter.is_active === false}
                        onChange={(e) => {
                          if (e.target.checked) {
                            user_list_filter = Object.assign(user_list_filter, ({ is_active: false }))
                          }
                          else {
                            user_list_filter = Object.assign(user_list_filter, ({ is_active: '' }))
                          }
                          this.setState({ user_list_filter })
                        }}
                      />
                      <label htmlFor="in_active" className="fitem-ck-txt">InActive</label>
                    </div>
                  </div>

                  <div className="fitem">
                    <label htmlFor="">Franchise</label>
                    <Select
                      placeholder='All'
                      defaultValue=""
                      value={user_list_filter?.staff_profile__field_office__uuid}
                      onChange={(e) => {
                        user_list_filter = Object.assign(user_list_filter, ({ staff_profile__field_office__uuid: e }));
                        this.setState({ user_list_filter })
                      }}
                      disabled={is_disable_franchise ? true : false}
                    >
                      <Option value="">All</Option>
                      {map(franchiseList, (item) => {
                        return (<Option key={item.uuid} >{item.name}</Option>)
                      })}
                    </Select>
                  </div>

                  <div className="fitem">
                    <label htmlFor="" className="">Joined</label>
                    <RangePicker
                      style={{ 'width': '100%' }}
                      allowClear={true}
                      inputReadOnly
                      value={user_list_filter?.created_at__gte && user_list_filter?.created_at__lte ? [moment(user_list_filter?.created_at__gte), moment(user_list_filter?.created_at__lte)] : ''}
                      onChange={(e) => {
                        if (e) {
                          user_list_filter = Object.assign(user_list_filter, { created_at__gte: `${moment(e[0]).format('YYYY-MM-DD')}T00:00:00`, created_at__lte: `${moment(e[1]).format('YYYY-MM-DD')}T11:59:59` });
                        }
                        else {
                          user_list_filter = Object.assign(user_list_filter, { created_at__lte: null, created_at__gte: null });
                          this.props.getUserList({ offset: 0, limit: 15, ...user_list_filter });
                        }

                        this.setState({
                          user_list_filter
                        })
                      }}
                      format='MMM DD, YYYY'
                      separator='-'
                    />
                  </div>
                  <div className="fitem">
                    <label htmlFor="">Role</label>
                    <Select
                      style={{ 'width': '100%' }}
                      placeholder='All'
                      defaultValue=""
                      value={user_list_filter.role}
                      onChange={(e) => {
                        user_list_filter = Object.assign(user_list_filter, ({ role: e }));
                        this.setState({ user_list_filter })
                      }}
                    >
                      <Option value="">All</Option>
                      {map(roleList, (item, i) => {
                        return (
                          <Option key={i} value={item.name}>{item.display_name}</Option>
                        )
                      })}
                    </Select>
                  </div>


                  <div className="fitem">
                    <label htmlFor="">Group</label>
                    <Select
                      style={{ 'width': '100%' }}
                      placeholder='All'
                      defaultValue=""
                      value={user_list_filter?.group__uuid}
                      onChange={(e) => {
                        user_list_filter = Object.assign(user_list_filter, ({ group__uuid: e }));
                        this.setState({ user_list_filter })
                      }}
                    >
                      <Option value="">All</Option>
                      {map(groupList, (item, i) => {
                        return (
                          <Option key={i} value={item.uuid} >{item.name}</Option>
                        )
                      })}
                    </Select>
                  </div>
                </div>
              </div>

              <div className="footer" >
                <button
                  className="btn btn-warning"
                  onClick={() => {
                    user_list_filter = Object.assign(user_list_filter, {
                      created_at__lte: null,
                      created_at__gte: null,
                      staff_profile__field_office__uuid: '',
                      status: '',
                      role: '',
                      is_active: '',
                      group__uuid: ''
                    });
                    this.setState({
                      user_list_filter,
                      loader: true
                    });


                    this.props.getUserList({ offset: 0, limit: 15 });

                  }}
                >Clear</button>
                <button
                  className="btn btn-bdr"
                  onClick={() => {
                    this.setState({
                      is_user_filter: false,
                    })

                  }}
                >Cancel</button>
                <button
                  className='btn btn-primary'
                  onClick={() => {

                    this.setState({
                      loader: true
                    })
                    let data = {
                      'offset': 0, 'limit': 15, ...user_list_filter
                    }
                    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
                    this.props.getUserList(data);
                  }}
                >Filter Users</button>
              </div>
            </div>


          </div>
        </Drawer>
      </div >
    );
  }
}

export default UserList;